// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.main-users-admin{
    width: 100%;
    height: 100%;
    position: relative;
    background-color: transparent;
    display: flex;
    justify-content: center;
    align-items: center;
}
.content-users-admin{
    position: relative;
    justify-content: center;
    display: flex;
    height: 98%;
    width: 94%;
/* background-color: rgba(37, 37, 37, 0.151); */
border-radius:10px ;
}
.block-users-admin{
    position: relative;
    width: 50%;
    height: 100%;
    display: flex;
    justify-content: center;
    align-items: center;
    
}
.NotifiAdminCont{
    width: 100%;
}
.card-users{
    position: relative;
    display: block;
    width: 90%;
    height: 98%;
    z-index: 1;
    box-shadow: 0 0 5px 5px rgba(24, 94, 224, 0.15), 0 6px 12px 0 rgba(24, 94, 224, 0.15);
    /* background: rgba(195,195,195,1); */
    /* border: 0.5px solid rgba(195,195,195); */
    border: 2px solid #003757 ;
    border-radius: 10px;
    overflow: hidden;
    /* outline: 2px solid white; */
}
.head-card-users{
    position: relative;
    height: 10%;
    width: 100%;
    /* background: rgba(195,195,195); */
    background: #003757;
    display: flex;
    justify-content: center;
    align-items: center;
}
.title-head-card-users{
    /* color:#003757  ; */
    color: var(--white-color);
    font-size: var(--font-size-small);
    letter-spacing: 1px;
}
.content-card-users{
    position: relative;
    height: 90%;
    width: 100%;
    display: flex;
    justify-content: center;
    align-items: center;
}
.title-user-box-admin{
    position: relative;
    display: flex;
    justify-content: center;
    align-items: center;
    width: 100%;
    height: 10%;
}
.txt-title-user-box-admin{
    font-size: large;
    color: #505050;

}
.input-admin{
    border-bottom: 2px solid rgba(195,195,195) !important;
  border-right: 2px solid rgba(195,195,195) !important;
}
/* .label-admin{
    color: rgba(195,195,195) !important;
} */

.form-admin-box{
    position: relative;
    display: block;
    width: 80%;
    height: 90%;
}
.user-box-admin{
    position: relative;
    display: flex;
    justify-content: center;
    align-items: center;
    width: 100%;
    height: 20%;
}

.form-admin-box .user-box-admin input {
    width: 100%;
    padding: 10px 0;
    font-size: 16px;
    color: #505050;
    margin-bottom: 30px;
    border: none;
    border-bottom: 2px solid #003757;
    border-right: 2px solid #003757;
    outline: none;
    background: transparent;
  }
  
  .form-admin-box .user-box-admin .label-admin {
    position: absolute;
    top: 15px;
    left: 0;
    padding: 10px 0;
    font-size: 18px;
    font-weight: bolder;
    color: #003757;
    pointer-events: none;
    transition: .5s;
  }
  
  .form-admin-box .user-box-admin input:focus ~ .label-admin,
  .form-admin-box .user-box-admin input:valid ~ .label-admin {
    top: -10px;
    left: 0;
    color: #003757;
    font-size: 12px;
  }

  .form-admin-box .user-box-admin .labelSelector {
    position: absolute;
    top: -25px;
    z-index: 2;
    left: 0;
    padding: 10px 0;
    font-size: 18px;
    font-weight: bolder;
    color: #003757;
    pointer-events: none;
    transition: .5s;
  }

  .content-box-admin{
    position: relative;
    display: block;
    justify-content: center;
    align-items: center;
    width: 100%;
    height: 70%;
  }

  .content-roles{
    position: relative;
    display: flex;
    justify-content: center;
    align-items: center;
    width: 100%;
    height: 15%;
  }
.box-options{
    display: flex;
    width: 100%;
    height: 100%;
}

.box-text{
    position: relative;
    display: flex;
    justify-content: center;
    align-items: center;
    width: 30%;
    height: 100%;
}
.txt-box-text{
    font-size: large;
    color: #003757;
}
  .tabs-roles {
    display: flex;
    position: relative;
    /* background-color: #fff; */
    /* box-shadow: 0 0 1px 0 rgba(24, 94, 224, 0.15), 0 6px 12px 0 rgba(24, 94, 224, 0.15); */
    /* padding: 0.75rem; */
    border-radius: 99px;
    height: 100%;
    border: 2px solid var(--border-table-color);
  border-radius: 4px;
  }
  
  .tabs-roles * {
    z-index: 2;
  }
  
  .container-tabs-roles input[type="radio"] {
    display: none;
  }
  
  .option-role {
    display: flex;
    align-items: center;
    justify-content: center;
    height: 100%;
    width: 100px;
    font-size: var(--font-size-small);
    color: #003757;
    font-weight: 500;
    border-radius: 99px;
    cursor: pointer;
    transition: color 0.15s ease-in;
    text-align: center;
    padding: 2%;
  }
  
  .notification {
    display: flex;
    align-items: center;
    justify-content: center;
    width: .8rem;
    height: .8rem;
    position: absolute;
    top: 10px;
    left: 30%;
    font-size: 10px;
    margin-left: 0.75rem;
    border-radius: 50%;
    margin: 0px;
    background-color: #e6eef9;
    transition: 0.15s ease-in;
  }
  
  .container-tabs-roles input[type="radio"]:checked + label {
    color: aliceblue;
  }
  
  .container-tabs-roles input[type="radio"]:checked + label > .notification {
    background-color: aliceblue;
    color: #fff;
    margin: 0px;
  }
  
  .container-tabs-roles input[id="radio-1"]:checked ~ .glider {
    transform: translateX(0);
  }
  
  .container-tabs-roles input[id="radio-2"]:checked ~ .glider {
    transform: translateX(100%);
  }
  
  .container-tabs-roles input[id="radio-3"]:checked ~ .glider {
    transform: translateX(200%);
  }
  .container-tabs-roles{
    position: absolute;
  width: 100%;
  /* left: 4%; */
  height: 100%;
  display: flex;
  display: block;
  }
  .glider {
    position: absolute;
    display: flex;
    height: 25px;
    width: 100px;
    background-color: #003757de;
    z-index: 1;
    border-radius: 99px;
    transition: 0.25s ease-out;
    top:20%
  }
  
  @media (max-width: 700px) {
   
    .tabs-roles {
      transform: scale(0.6);
    }
  }
  

  /***************************************************************************/
  .content-permissions{
    position: relative;
    display: flex;
    justify-content: center;
    align-items: center;
    width: 100%;
    height: 85%;
    /* background-color: #003757; */
  }

  .table-permissions{
    position: relative;
    display: block;
    width: 50%;
    height: 90%;
    z-index: 1;
    /* box-shadow: 0 0 5px 5px rgba(24, 94, 224, 0.15), 0 6px 12px 0 rgba(24, 94, 224, 0.15); */
    /* background: rgba(195,195,195,1); */
    /* border: 0.5px solid rgba(195,195,195); */
    border: 2px solid var(--border-table-color) ;
    border-radius: 10px;
    overflow: hidden;
    /* outline: 2px solid white; */
  }
  .content-list-permissions{
    position: relative;
    display: flex;
    justify-content: center;
    align-items: center;
    width: 100%;
    height: 90%;

  }

  .center-content-list{
    position: relative;
    display: block;
    justify-content: center;
    align-items: center;
    width: 95%;
    height: 95%;
    overflow: auto;
  }
  .compact-option-permission{
    position: relative;
    display: flex;
    justify-content: center;
    align-items: center;
    width: 100%;
    height: 15%;
  }

  .cyberpunk-checkbox {
    appearance: none;
    width: 20px;
    height: 20px;
    border: 2px solid #003757;
    border-radius: 10px;
    background-color: transparent;
    display: inline-block;
    position: relative;
    margin-right: 10px;
    cursor: pointer;
  }
  
  .cyberpunk-checkbox:before {
    content: "";
    background-color: var(--third-color);
    display: block;
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%) scale(0);
    width: 12px;
    height: 12px;
    border-radius: 10px;
    transition: all 0.3s ease-in-out;
  }
  
  .cyberpunk-checkbox:checked:before {
    transform: translate(-50%, -50%) scale(1);
  }
  
  .cyberpunk-checkbox-label {
    font-size: var(--font-size-small);
    color: var(--txt-color);
    cursor: pointer;
    -webkit-user-select: none;
            user-select: none;
    display: flex;
    align-items: center;
    width: 80%;
    height: 100%;
  }
  .cyberpunk-checkbox-label:hover{
    background-color: #e6eef9;
  }

  .NotifiAdmin .cont-table-roles {
    width: 100%;
    height: 100%;
  }
 
  .NotifiAdmin .head-table-users{
    justify-content: start;
  }
 .NotifiCheckBox{
    width: 50%;
  height: 50%;
 }
.headNotifiAdmi{
    width: 70%;
    height: 100%; 
    position: relative;
    display: flex;
    justify-content: center;
    align-items: center;
    text-align: center;
}
.headNotifiAdmi:hover .tooltiptextNotifi {
  visibility: visible;
  opacity: 1;
 
}
.headNotifiAdmi:hover{
  cursor: pointer;
}
.tooltiptextNotifi {
  visibility: hidden;
  opacity: 0;
  width: auto;
  background-color: #929292ef;
  border: #003757 2px solid;
  color: rgb(245, 245, 245);
  font-weight: bold;
  text-align: center;
  border-radius: 5px;
  /* padding: 10px; */
  position: absolute;
  z-index: 10;
  /* display: flex; */
  justify-content: center;
  align-items: center;
  /* bottom: 80%; */
  left: 80%;
  transform: translateX(-50%);
  height: 20px;
  transition: opacity 0.3s;
  white-space: nowrap;
  top: 100%;
  font-size: small;
  margin: 5px;
}
.tooltiptextNotifi::after {
  content: "";
  position: absolute;
  top: 100%;
  left:50%;
  border-width: 8px;
  border-style: solid;
  border-color: #28282817 transparent transparent transparent;
  transform: translateX(-50%);
}
.contCheckNotifiAdmi{
    width: 30%;
    height: 100%; 
    position: relative;
    display: block;
    justify-content: center;
    align-items: center;
}
.contCheckNotifiAdmi .title{
    width: 100%;
    height: 30%;
    position: relative;
    top:10%;
    display: flex;
    justify-content: center;
    align-items: center;
    font-size: small;
}
.contCheckNotifiAdmi .input{
    width: 100%;
    height: 70%;
    justify-content: center;
    align-items: center;
    display: flex;
}
`, "",{"version":3,"sources":["webpack://./src/components/admin-components/styles/NotifiAdmin.css"],"names":[],"mappings":"AAAA;IACI,WAAW;IACX,YAAY;IACZ,kBAAkB;IAClB,6BAA6B;IAC7B,aAAa;IACb,uBAAuB;IACvB,mBAAmB;AACvB;AACA;IACI,kBAAkB;IAClB,uBAAuB;IACvB,aAAa;IACb,WAAW;IACX,UAAU;AACd,+CAA+C;AAC/C,mBAAmB;AACnB;AACA;IACI,kBAAkB;IAClB,UAAU;IACV,YAAY;IACZ,aAAa;IACb,uBAAuB;IACvB,mBAAmB;;AAEvB;AACA;IACI,WAAW;AACf;AACA;IACI,kBAAkB;IAClB,cAAc;IACd,UAAU;IACV,WAAW;IACX,UAAU;IACV,qFAAqF;IACrF,qCAAqC;IACrC,2CAA2C;IAC3C,0BAA0B;IAC1B,mBAAmB;IACnB,gBAAgB;IAChB,8BAA8B;AAClC;AACA;IACI,kBAAkB;IAClB,WAAW;IACX,WAAW;IACX,mCAAmC;IACnC,mBAAmB;IACnB,aAAa;IACb,uBAAuB;IACvB,mBAAmB;AACvB;AACA;IACI,qBAAqB;IACrB,yBAAyB;IACzB,iCAAiC;IACjC,mBAAmB;AACvB;AACA;IACI,kBAAkB;IAClB,WAAW;IACX,WAAW;IACX,aAAa;IACb,uBAAuB;IACvB,mBAAmB;AACvB;AACA;IACI,kBAAkB;IAClB,aAAa;IACb,uBAAuB;IACvB,mBAAmB;IACnB,WAAW;IACX,WAAW;AACf;AACA;IACI,gBAAgB;IAChB,cAAc;;AAElB;AACA;IACI,qDAAqD;EACvD,oDAAoD;AACtD;AACA;;GAEG;;AAEH;IACI,kBAAkB;IAClB,cAAc;IACd,UAAU;IACV,WAAW;AACf;AACA;IACI,kBAAkB;IAClB,aAAa;IACb,uBAAuB;IACvB,mBAAmB;IACnB,WAAW;IACX,WAAW;AACf;;AAEA;IACI,WAAW;IACX,eAAe;IACf,eAAe;IACf,cAAc;IACd,mBAAmB;IACnB,YAAY;IACZ,gCAAgC;IAChC,+BAA+B;IAC/B,aAAa;IACb,uBAAuB;EACzB;;EAEA;IACE,kBAAkB;IAClB,SAAS;IACT,OAAO;IACP,eAAe;IACf,eAAe;IACf,mBAAmB;IACnB,cAAc;IACd,oBAAoB;IACpB,eAAe;EACjB;;EAEA;;IAEE,UAAU;IACV,OAAO;IACP,cAAc;IACd,eAAe;EACjB;;EAEA;IACE,kBAAkB;IAClB,UAAU;IACV,UAAU;IACV,OAAO;IACP,eAAe;IACf,eAAe;IACf,mBAAmB;IACnB,cAAc;IACd,oBAAoB;IACpB,eAAe;EACjB;;EAEA;IACE,kBAAkB;IAClB,cAAc;IACd,uBAAuB;IACvB,mBAAmB;IACnB,WAAW;IACX,WAAW;EACb;;EAEA;IACE,kBAAkB;IAClB,aAAa;IACb,uBAAuB;IACvB,mBAAmB;IACnB,WAAW;IACX,WAAW;EACb;AACF;IACI,aAAa;IACb,WAAW;IACX,YAAY;AAChB;;AAEA;IACI,kBAAkB;IAClB,aAAa;IACb,uBAAuB;IACvB,mBAAmB;IACnB,UAAU;IACV,YAAY;AAChB;AACA;IACI,gBAAgB;IAChB,cAAc;AAClB;EACE;IACE,aAAa;IACb,kBAAkB;IAClB,4BAA4B;IAC5B,yFAAyF;IACzF,sBAAsB;IACtB,mBAAmB;IACnB,YAAY;IACZ,2CAA2C;EAC7C,kBAAkB;EAClB;;EAEA;IACE,UAAU;EACZ;;EAEA;IACE,aAAa;EACf;;EAEA;IACE,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,YAAY;IACZ,YAAY;IACZ,iCAAiC;IACjC,cAAc;IACd,gBAAgB;IAChB,mBAAmB;IACnB,eAAe;IACf,+BAA+B;IAC/B,kBAAkB;IAClB,WAAW;EACb;;EAEA;IACE,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,YAAY;IACZ,aAAa;IACb,kBAAkB;IAClB,SAAS;IACT,SAAS;IACT,eAAe;IACf,oBAAoB;IACpB,kBAAkB;IAClB,WAAW;IACX,yBAAyB;IACzB,yBAAyB;EAC3B;;EAEA;IACE,gBAAgB;EAClB;;EAEA;IACE,2BAA2B;IAC3B,WAAW;IACX,WAAW;EACb;;EAEA;IACE,wBAAwB;EAC1B;;EAEA;IACE,2BAA2B;EAC7B;;EAEA;IACE,2BAA2B;EAC7B;EACA;IACE,kBAAkB;EACpB,WAAW;EACX,cAAc;EACd,YAAY;EACZ,aAAa;EACb,cAAc;EACd;EACA;IACE,kBAAkB;IAClB,aAAa;IACb,YAAY;IACZ,YAAY;IACZ,2BAA2B;IAC3B,UAAU;IACV,mBAAmB;IACnB,0BAA0B;IAC1B;EACF;;EAEA;;IAEE;MACE,qBAAqB;IACvB;EACF;;;EAGA,4EAA4E;EAC5E;IACE,kBAAkB;IAClB,aAAa;IACb,uBAAuB;IACvB,mBAAmB;IACnB,WAAW;IACX,WAAW;IACX,+BAA+B;EACjC;;EAEA;IACE,kBAAkB;IAClB,cAAc;IACd,UAAU;IACV,WAAW;IACX,UAAU;IACV,2FAA2F;IAC3F,qCAAqC;IACrC,2CAA2C;IAC3C,4CAA4C;IAC5C,mBAAmB;IACnB,gBAAgB;IAChB,8BAA8B;EAChC;EACA;IACE,kBAAkB;IAClB,aAAa;IACb,uBAAuB;IACvB,mBAAmB;IACnB,WAAW;IACX,WAAW;;EAEb;;EAEA;IACE,kBAAkB;IAClB,cAAc;IACd,uBAAuB;IACvB,mBAAmB;IACnB,UAAU;IACV,WAAW;IACX,cAAc;EAChB;EACA;IACE,kBAAkB;IAClB,aAAa;IACb,uBAAuB;IACvB,mBAAmB;IACnB,WAAW;IACX,WAAW;EACb;;EAEA;IACE,gBAAgB;IAChB,WAAW;IACX,YAAY;IACZ,yBAAyB;IACzB,mBAAmB;IACnB,6BAA6B;IAC7B,qBAAqB;IACrB,kBAAkB;IAClB,kBAAkB;IAClB,eAAe;EACjB;;EAEA;IACE,WAAW;IACX,oCAAoC;IACpC,cAAc;IACd,kBAAkB;IAClB,QAAQ;IACR,SAAS;IACT,yCAAyC;IACzC,WAAW;IACX,YAAY;IACZ,mBAAmB;IACnB,gCAAgC;EAClC;;EAEA;IACE,yCAAyC;EAC3C;;EAEA;IACE,iCAAiC;IACjC,uBAAuB;IACvB,eAAe;IACf,yBAAiB;YAAjB,iBAAiB;IACjB,aAAa;IACb,mBAAmB;IACnB,UAAU;IACV,YAAY;EACd;EACA;IACE,yBAAyB;EAC3B;;EAEA;IACE,WAAW;IACX,YAAY;EACd;;EAEA;IACE,sBAAsB;EACxB;CACD;IACG,UAAU;EACZ,WAAW;CACZ;AACD;IACI,UAAU;IACV,YAAY;IACZ,kBAAkB;IAClB,aAAa;IACb,uBAAuB;IACvB,mBAAmB;IACnB,kBAAkB;AACtB;AACA;EACE,mBAAmB;EACnB,UAAU;;AAEZ;AACA;EACE,eAAe;AACjB;AACA;EACE,kBAAkB;EAClB,UAAU;EACV,WAAW;EACX,2BAA2B;EAC3B,yBAAyB;EACzB,yBAAyB;EACzB,iBAAiB;EACjB,kBAAkB;EAClB,kBAAkB;EAClB,mBAAmB;EACnB,kBAAkB;EAClB,WAAW;EACX,mBAAmB;EACnB,uBAAuB;EACvB,mBAAmB;EACnB,iBAAiB;EACjB,SAAS;EACT,2BAA2B;EAC3B,YAAY;EACZ,wBAAwB;EACxB,mBAAmB;EACnB,SAAS;EACT,gBAAgB;EAChB,WAAW;AACb;AACA;EACE,WAAW;EACX,kBAAkB;EAClB,SAAS;EACT,QAAQ;EACR,iBAAiB;EACjB,mBAAmB;EACnB,2DAA2D;EAC3D,2BAA2B;AAC7B;AACA;IACI,UAAU;IACV,YAAY;IACZ,kBAAkB;IAClB,cAAc;IACd,uBAAuB;IACvB,mBAAmB;AACvB;AACA;IACI,WAAW;IACX,WAAW;IACX,kBAAkB;IAClB,OAAO;IACP,aAAa;IACb,uBAAuB;IACvB,mBAAmB;IACnB,gBAAgB;AACpB;AACA;IACI,WAAW;IACX,WAAW;IACX,uBAAuB;IACvB,mBAAmB;IACnB,aAAa;AACjB","sourcesContent":[".main-users-admin{\r\n    width: 100%;\r\n    height: 100%;\r\n    position: relative;\r\n    background-color: transparent;\r\n    display: flex;\r\n    justify-content: center;\r\n    align-items: center;\r\n}\r\n.content-users-admin{\r\n    position: relative;\r\n    justify-content: center;\r\n    display: flex;\r\n    height: 98%;\r\n    width: 94%;\r\n/* background-color: rgba(37, 37, 37, 0.151); */\r\nborder-radius:10px ;\r\n}\r\n.block-users-admin{\r\n    position: relative;\r\n    width: 50%;\r\n    height: 100%;\r\n    display: flex;\r\n    justify-content: center;\r\n    align-items: center;\r\n    \r\n}\r\n.NotifiAdminCont{\r\n    width: 100%;\r\n}\r\n.card-users{\r\n    position: relative;\r\n    display: block;\r\n    width: 90%;\r\n    height: 98%;\r\n    z-index: 1;\r\n    box-shadow: 0 0 5px 5px rgba(24, 94, 224, 0.15), 0 6px 12px 0 rgba(24, 94, 224, 0.15);\r\n    /* background: rgba(195,195,195,1); */\r\n    /* border: 0.5px solid rgba(195,195,195); */\r\n    border: 2px solid #003757 ;\r\n    border-radius: 10px;\r\n    overflow: hidden;\r\n    /* outline: 2px solid white; */\r\n}\r\n.head-card-users{\r\n    position: relative;\r\n    height: 10%;\r\n    width: 100%;\r\n    /* background: rgba(195,195,195); */\r\n    background: #003757;\r\n    display: flex;\r\n    justify-content: center;\r\n    align-items: center;\r\n}\r\n.title-head-card-users{\r\n    /* color:#003757  ; */\r\n    color: var(--white-color);\r\n    font-size: var(--font-size-small);\r\n    letter-spacing: 1px;\r\n}\r\n.content-card-users{\r\n    position: relative;\r\n    height: 90%;\r\n    width: 100%;\r\n    display: flex;\r\n    justify-content: center;\r\n    align-items: center;\r\n}\r\n.title-user-box-admin{\r\n    position: relative;\r\n    display: flex;\r\n    justify-content: center;\r\n    align-items: center;\r\n    width: 100%;\r\n    height: 10%;\r\n}\r\n.txt-title-user-box-admin{\r\n    font-size: large;\r\n    color: #505050;\r\n\r\n}\r\n.input-admin{\r\n    border-bottom: 2px solid rgba(195,195,195) !important;\r\n  border-right: 2px solid rgba(195,195,195) !important;\r\n}\r\n/* .label-admin{\r\n    color: rgba(195,195,195) !important;\r\n} */\r\n\r\n.form-admin-box{\r\n    position: relative;\r\n    display: block;\r\n    width: 80%;\r\n    height: 90%;\r\n}\r\n.user-box-admin{\r\n    position: relative;\r\n    display: flex;\r\n    justify-content: center;\r\n    align-items: center;\r\n    width: 100%;\r\n    height: 20%;\r\n}\r\n\r\n.form-admin-box .user-box-admin input {\r\n    width: 100%;\r\n    padding: 10px 0;\r\n    font-size: 16px;\r\n    color: #505050;\r\n    margin-bottom: 30px;\r\n    border: none;\r\n    border-bottom: 2px solid #003757;\r\n    border-right: 2px solid #003757;\r\n    outline: none;\r\n    background: transparent;\r\n  }\r\n  \r\n  .form-admin-box .user-box-admin .label-admin {\r\n    position: absolute;\r\n    top: 15px;\r\n    left: 0;\r\n    padding: 10px 0;\r\n    font-size: 18px;\r\n    font-weight: bolder;\r\n    color: #003757;\r\n    pointer-events: none;\r\n    transition: .5s;\r\n  }\r\n  \r\n  .form-admin-box .user-box-admin input:focus ~ .label-admin,\r\n  .form-admin-box .user-box-admin input:valid ~ .label-admin {\r\n    top: -10px;\r\n    left: 0;\r\n    color: #003757;\r\n    font-size: 12px;\r\n  }\r\n\r\n  .form-admin-box .user-box-admin .labelSelector {\r\n    position: absolute;\r\n    top: -25px;\r\n    z-index: 2;\r\n    left: 0;\r\n    padding: 10px 0;\r\n    font-size: 18px;\r\n    font-weight: bolder;\r\n    color: #003757;\r\n    pointer-events: none;\r\n    transition: .5s;\r\n  }\r\n\r\n  .content-box-admin{\r\n    position: relative;\r\n    display: block;\r\n    justify-content: center;\r\n    align-items: center;\r\n    width: 100%;\r\n    height: 70%;\r\n  }\r\n\r\n  .content-roles{\r\n    position: relative;\r\n    display: flex;\r\n    justify-content: center;\r\n    align-items: center;\r\n    width: 100%;\r\n    height: 15%;\r\n  }\r\n.box-options{\r\n    display: flex;\r\n    width: 100%;\r\n    height: 100%;\r\n}\r\n\r\n.box-text{\r\n    position: relative;\r\n    display: flex;\r\n    justify-content: center;\r\n    align-items: center;\r\n    width: 30%;\r\n    height: 100%;\r\n}\r\n.txt-box-text{\r\n    font-size: large;\r\n    color: #003757;\r\n}\r\n  .tabs-roles {\r\n    display: flex;\r\n    position: relative;\r\n    /* background-color: #fff; */\r\n    /* box-shadow: 0 0 1px 0 rgba(24, 94, 224, 0.15), 0 6px 12px 0 rgba(24, 94, 224, 0.15); */\r\n    /* padding: 0.75rem; */\r\n    border-radius: 99px;\r\n    height: 100%;\r\n    border: 2px solid var(--border-table-color);\r\n  border-radius: 4px;\r\n  }\r\n  \r\n  .tabs-roles * {\r\n    z-index: 2;\r\n  }\r\n  \r\n  .container-tabs-roles input[type=\"radio\"] {\r\n    display: none;\r\n  }\r\n  \r\n  .option-role {\r\n    display: flex;\r\n    align-items: center;\r\n    justify-content: center;\r\n    height: 100%;\r\n    width: 100px;\r\n    font-size: var(--font-size-small);\r\n    color: #003757;\r\n    font-weight: 500;\r\n    border-radius: 99px;\r\n    cursor: pointer;\r\n    transition: color 0.15s ease-in;\r\n    text-align: center;\r\n    padding: 2%;\r\n  }\r\n  \r\n  .notification {\r\n    display: flex;\r\n    align-items: center;\r\n    justify-content: center;\r\n    width: .8rem;\r\n    height: .8rem;\r\n    position: absolute;\r\n    top: 10px;\r\n    left: 30%;\r\n    font-size: 10px;\r\n    margin-left: 0.75rem;\r\n    border-radius: 50%;\r\n    margin: 0px;\r\n    background-color: #e6eef9;\r\n    transition: 0.15s ease-in;\r\n  }\r\n  \r\n  .container-tabs-roles input[type=\"radio\"]:checked + label {\r\n    color: aliceblue;\r\n  }\r\n  \r\n  .container-tabs-roles input[type=\"radio\"]:checked + label > .notification {\r\n    background-color: aliceblue;\r\n    color: #fff;\r\n    margin: 0px;\r\n  }\r\n  \r\n  .container-tabs-roles input[id=\"radio-1\"]:checked ~ .glider {\r\n    transform: translateX(0);\r\n  }\r\n  \r\n  .container-tabs-roles input[id=\"radio-2\"]:checked ~ .glider {\r\n    transform: translateX(100%);\r\n  }\r\n  \r\n  .container-tabs-roles input[id=\"radio-3\"]:checked ~ .glider {\r\n    transform: translateX(200%);\r\n  }\r\n  .container-tabs-roles{\r\n    position: absolute;\r\n  width: 100%;\r\n  /* left: 4%; */\r\n  height: 100%;\r\n  display: flex;\r\n  display: block;\r\n  }\r\n  .glider {\r\n    position: absolute;\r\n    display: flex;\r\n    height: 25px;\r\n    width: 100px;\r\n    background-color: #003757de;\r\n    z-index: 1;\r\n    border-radius: 99px;\r\n    transition: 0.25s ease-out;\r\n    top:20%\r\n  }\r\n  \r\n  @media (max-width: 700px) {\r\n   \r\n    .tabs-roles {\r\n      transform: scale(0.6);\r\n    }\r\n  }\r\n  \r\n\r\n  /***************************************************************************/\r\n  .content-permissions{\r\n    position: relative;\r\n    display: flex;\r\n    justify-content: center;\r\n    align-items: center;\r\n    width: 100%;\r\n    height: 85%;\r\n    /* background-color: #003757; */\r\n  }\r\n\r\n  .table-permissions{\r\n    position: relative;\r\n    display: block;\r\n    width: 50%;\r\n    height: 90%;\r\n    z-index: 1;\r\n    /* box-shadow: 0 0 5px 5px rgba(24, 94, 224, 0.15), 0 6px 12px 0 rgba(24, 94, 224, 0.15); */\r\n    /* background: rgba(195,195,195,1); */\r\n    /* border: 0.5px solid rgba(195,195,195); */\r\n    border: 2px solid var(--border-table-color) ;\r\n    border-radius: 10px;\r\n    overflow: hidden;\r\n    /* outline: 2px solid white; */\r\n  }\r\n  .content-list-permissions{\r\n    position: relative;\r\n    display: flex;\r\n    justify-content: center;\r\n    align-items: center;\r\n    width: 100%;\r\n    height: 90%;\r\n\r\n  }\r\n\r\n  .center-content-list{\r\n    position: relative;\r\n    display: block;\r\n    justify-content: center;\r\n    align-items: center;\r\n    width: 95%;\r\n    height: 95%;\r\n    overflow: auto;\r\n  }\r\n  .compact-option-permission{\r\n    position: relative;\r\n    display: flex;\r\n    justify-content: center;\r\n    align-items: center;\r\n    width: 100%;\r\n    height: 15%;\r\n  }\r\n\r\n  .cyberpunk-checkbox {\r\n    appearance: none;\r\n    width: 20px;\r\n    height: 20px;\r\n    border: 2px solid #003757;\r\n    border-radius: 10px;\r\n    background-color: transparent;\r\n    display: inline-block;\r\n    position: relative;\r\n    margin-right: 10px;\r\n    cursor: pointer;\r\n  }\r\n  \r\n  .cyberpunk-checkbox:before {\r\n    content: \"\";\r\n    background-color: var(--third-color);\r\n    display: block;\r\n    position: absolute;\r\n    top: 50%;\r\n    left: 50%;\r\n    transform: translate(-50%, -50%) scale(0);\r\n    width: 12px;\r\n    height: 12px;\r\n    border-radius: 10px;\r\n    transition: all 0.3s ease-in-out;\r\n  }\r\n  \r\n  .cyberpunk-checkbox:checked:before {\r\n    transform: translate(-50%, -50%) scale(1);\r\n  }\r\n  \r\n  .cyberpunk-checkbox-label {\r\n    font-size: var(--font-size-small);\r\n    color: var(--txt-color);\r\n    cursor: pointer;\r\n    user-select: none;\r\n    display: flex;\r\n    align-items: center;\r\n    width: 80%;\r\n    height: 100%;\r\n  }\r\n  .cyberpunk-checkbox-label:hover{\r\n    background-color: #e6eef9;\r\n  }\r\n\r\n  .NotifiAdmin .cont-table-roles {\r\n    width: 100%;\r\n    height: 100%;\r\n  }\r\n \r\n  .NotifiAdmin .head-table-users{\r\n    justify-content: start;\r\n  }\r\n .NotifiCheckBox{\r\n    width: 50%;\r\n  height: 50%;\r\n }\r\n.headNotifiAdmi{\r\n    width: 70%;\r\n    height: 100%; \r\n    position: relative;\r\n    display: flex;\r\n    justify-content: center;\r\n    align-items: center;\r\n    text-align: center;\r\n}\r\n.headNotifiAdmi:hover .tooltiptextNotifi {\r\n  visibility: visible;\r\n  opacity: 1;\r\n \r\n}\r\n.headNotifiAdmi:hover{\r\n  cursor: pointer;\r\n}\r\n.tooltiptextNotifi {\r\n  visibility: hidden;\r\n  opacity: 0;\r\n  width: auto;\r\n  background-color: #929292ef;\r\n  border: #003757 2px solid;\r\n  color: rgb(245, 245, 245);\r\n  font-weight: bold;\r\n  text-align: center;\r\n  border-radius: 5px;\r\n  /* padding: 10px; */\r\n  position: absolute;\r\n  z-index: 10;\r\n  /* display: flex; */\r\n  justify-content: center;\r\n  align-items: center;\r\n  /* bottom: 80%; */\r\n  left: 80%;\r\n  transform: translateX(-50%);\r\n  height: 20px;\r\n  transition: opacity 0.3s;\r\n  white-space: nowrap;\r\n  top: 100%;\r\n  font-size: small;\r\n  margin: 5px;\r\n}\r\n.tooltiptextNotifi::after {\r\n  content: \"\";\r\n  position: absolute;\r\n  top: 100%;\r\n  left:50%;\r\n  border-width: 8px;\r\n  border-style: solid;\r\n  border-color: #28282817 transparent transparent transparent;\r\n  transform: translateX(-50%);\r\n}\r\n.contCheckNotifiAdmi{\r\n    width: 30%;\r\n    height: 100%; \r\n    position: relative;\r\n    display: block;\r\n    justify-content: center;\r\n    align-items: center;\r\n}\r\n.contCheckNotifiAdmi .title{\r\n    width: 100%;\r\n    height: 30%;\r\n    position: relative;\r\n    top:10%;\r\n    display: flex;\r\n    justify-content: center;\r\n    align-items: center;\r\n    font-size: small;\r\n}\r\n.contCheckNotifiAdmi .input{\r\n    width: 100%;\r\n    height: 70%;\r\n    justify-content: center;\r\n    align-items: center;\r\n    display: flex;\r\n}\r\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
